import trim from "./trim";

/**
 * Converts a string to kebab-case.
 * Handles camelCase, PascalCase, and space-separated strings.
 *
 * @param value The string to convert
 * @returns A kebab-case formatted string
 */
export default function kebabCase(value: string): string {
	if (!value) return "";

	const withSpacesHandled = value.replace(/\s+/g, "-");
	const kebabString = withSpacesHandled
		// Split an acronym from a following capitalized word: "SQLData" -> "SQL-Data"
		.replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
		// Split a lowercase letter or digit from a following uppercase letter: "camelCase" -> "camel-Case"
		.replace(/([a-z0-9])([A-Z])/g, "$1-$2")
		.toLowerCase();

	return trim(kebabString.replace(/-+/g, "-"), "-");
}
